<template>
  <base-layout>
    <template #sidebar>
      <ui-settings-sidebar/>
    </template>
    <template #breadcrumbs>
      <ui-breadcrumbs
        :breadcrumbs="breadcrumbs"
        :title="title"
      />
    </template>
    <div class="bg-white shadow-sm p-3">
      <div class="mb-3 d-flex justify-content-between">
        <ui-back-button :href="route('users.index')"/>
        <ui-delete-button
          v-if="!isNew"
          @delete="deleteClick"
        />
      </div>
      <ui-errors/>
      <el-form
        ref="users_form"
        v-loading="form.processing"
        :model="form"
        label-position="top"
        :rules="rules"
        @submit.native.prevent="submit"
      >
        <div class="row">
          <div class="col-4">
            <el-form-item
              label="Фио"
              prop="name"
            >
              <el-input
                id="name"
                v-model="form.name"
                placeholder="Введите ФИО"
                autofocus
                @keyup.enter.native="submit"
              />
            </el-form-item>
          </div>
          <div class="col-4">
            <el-form-item
              label="Логин (Email)"
              prop="email"
            >
              <el-input
                id="email"
                v-model="form.email"
                placeholder="Логин (Email)"
                autofocus
                @keyup.enter.native="submit"
              />
            </el-form-item>
          </div>
          <div class="col-4">
            <el-form-item
              label="Пароль"
              prop="password"
            >
              <el-input
                id="password"
                v-model="form.password"
                placeholder="Новый пароль"
                autofocus
                @keyup.enter.native="submit"
              />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <el-form-item
              label="Месторождения"
              prop="places"
            >
              <el-select
                id="places"
                style="width: 100%"
                v-model="form.places"
                filterable
                placeholder="Выберите месторождение"
                multiple
              >
                <el-option
                  v-for="(item, index) in places"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
          <div class="col-12 d-flex">
            <el-form-item
              label="Права доступов"
              prop="template_save_access"
              style="margin-right: 20px"
            >
              <el-checkbox
                id="template_save_access"
                v-model="form.template_save_access"
                label="Сохранение шаблонов"
                size="large"
              />
            </el-form-item>
            <el-form-item
              label="Админ"
              prop="is_admin"
            >
              <el-checkbox
                id="is_admin"
                v-model="form.is_admin"
                label="Администратор"
                size="large"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item label="Права на запросы">
              <el-checkbox-group
                v-model="form.reports"
              >
                <el-checkbox
                  v-for="item in reports"
                  :label="item.title"
                />
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-button
              style="width: 100%"
              icon="el-icon-check"
              type="primary"
              @click="submit"
            >
              Сохранить
            </el-button>
          </div>
          <div class="mt-2 col-12">
            <el-button
              style="width: 100%"
              icon="el-icon-warning"
              @click="reset"
            >
              Сбросить параметры
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
  </base-layout>
</template>

<script>
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiErrors from '@/components/Ui/UiErrors';
import UiDeleteButton from '@/components/Ui/UiDeleteButton';
import BaseLayout from "@/Layouts/BaseLayout";

export default {
  name: 'UsersForm',
  components: {
    BaseLayout,
    UiBreadcrumbs,
    UiErrors,
    UiDeleteButton,
  },
  props: {
    selected: {
      type: Array,
      default: []
    },
    reports: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    places: {
      type: Array,
      required: true,
    },
    errors: {
      type: Object,
      default: () => null
    },
  },
  data() {
    return {
      data_value: [],
      value: '',
      breadcrumbs: [],
      form: this.$inertia.form({
        _method: 'put',
        ...this.user,
        password: this.user.password
      }),
      rules: {
        name: [
          {required: true, message: 'Обязательное поле', trigger: 'blur'},
        ],
        email: [
          {required: true, message: 'Обязательное поле', trigger: 'blur'},
        ],
      },
    };
  },
  mounted() {
    this.form.reports = this.user.reports.map(item => {
      return this.reports[item]?.title;
    });
  },
  computed: {
    local_selected: {
      get() {
        return this.selected.map(function (item) {
          return {
            'id': item.id,
            'name': item.name
          }
        })
      },
      set(val) {
        const hasItem = this.selected.find(({id}) => id === val);
        if (!hasItem) {
          this.$emit('update:selected', [...this.selected, val]);
        } else {
          this.$emit('update:selected', this.selected.filter(({id}) => id !== val))
        }
      }
    },
    isNew() {
      return !(this.user.id);
    },
    title() {
      return this.isNew ? 'Создание записи' : 'Изменение записи';
    },
  },
  methods: {
    reset() {
      this.form.name = null;
      this.form.email = null;
      this.form.places = [];
      this.form.template_save_access = false;
      this.is_admin = false;
    },
    deleteClick() {
      this.$inertia.delete(route('users.destroy', this.user.id), {
        onSuccess: () => {
          this.$notify.success({
            title: 'Пользователь удалён',
          });
        },
        onError: (errors) => {
          this.$notify.error({
            title: 'Ошибка',
            message: errors.exeption[0],
          });
        },
      });
    },
    validate() {
      return this.$refs.users_form.validate();
    },
    submitForm(settings) {
      const url = this.isNew ? route('users.store') : route('users.update', this.user.id);
      // Так как PUT метод не поддерживает загрузку файлов
      if (!this.isNew) {
        this.form._method = 'put';
      } else {
        delete this.form._method;
      }

      for (let i = 0; i < this.form.reports.length; i++) {
        Object.entries(this.reports).forEach(item => {
          if (item[1].title === this.form.reports[i]) {
            this.form.reports[i] = item[0];
          }
        });
      }

      return this.form.post(url, settings);
    },
    submit() {
      this.validate().then(() => {
        this.submitForm({
          onSuccess: () => {
            this.$notify.success({
              title: this.isNew ? 'Пользователь сохранён' : 'Пользователь изменён',
            });
          },
          onError: () => {
            this.$notify.error({
              title: 'Ошибка сохранения',
              message: 'Исправьте введенные данные',
            });
          },
        });
      }).catch((err) => {
        this.$notify.error({
          title: 'Ошибки в форме',
          message: 'Заполните необходимые поля',
        });
      });
    },
  },
};
</script>
